<!-- @format -->

<template>
	<el-button
		:type="pcProps.buttonType"
		:link="pcProps.isLink"
		:color="pcProps.backgroundColor"
		:style="{
			color: pcProps.fontColor,
			borderRadius: `${pcProps.borderRadius}%`,
			height: pcProps.height,
			width: pcProps.width,
		}"
		@click="onClick"
	>
		{{ pcProps.label }}
	</el-button>
</template>

<script setup lang="ts">
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { type WidgetConfigType } from '../../types';

	interface Props {
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['click']);

	const onClick = () => {
		if (props.pcProps.isLink && props.pcProps.toUrl) {
			let url = props.pcProps.toUrl;
			url = getEnvUrlByUrl(url);

			if (props.pcProps.isRedirect) {
				window.location.href = url;
			} else {
				window.open(url);
			}
		}
		emit('click');
	};
</script>

<style scoped></style>
